export const EmailVerificationImage = require('./mail.svg');
export const SignicatCameraImage = require('./cam_ident.svg');
export const SignicatDocsImage = require('./doc_ident.svg');
